import React, { useEffect } from 'react';

/**
 * Smart App-Redirect Seite.
 * Wird aus WhatsApp/E-Mail-"Zur App"-Buttons aufgerufen.
 * Versucht zuerst die installierte StrongFit-App über das Custom-URL-Schema
 * (`strongfit://`) zu öffnen. Falls die App nicht reagiert (z. B. Desktop oder
 * App nicht installiert), wird nach 1.6s ins Web-Portal weitergeleitet.
 *
 * Query-Param `to=<screen>` (optional) kann ein bestimmtes In-App-Screen
 * adressieren. Wird sowohl an das Custom-Schema (`strongfit://<to>`) als auch
 * an die Web-Fallback-URL (`/portal/<to>`) angehängt.
 */
export default function AppRedirectPage() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const to = (params.get('to') || '').replace(/^\/+/, '');
    const appScheme = `strongfit://${to}`;
    // Web-Fallback: bekannte Ziele auf echte Portal-Pfade mappen.
    const webMap = {
      emergency: '/portal?focus=emergency',
      'profile-complete': '/portal?complete=1',
      profile: '/portal',
      invoices: '/portal',
    };
    const webFallback = webMap[to] || (to ? `/portal/${to}` : '/portal');

    let didFallback = false;

    // Sichtbarkeitswechsel = App hat übernommen → Fallback abbrechen
    const onVisibility = () => {
      if (document.hidden) didFallback = true;
    };
    document.addEventListener('visibilitychange', onVisibility);

    // Versuche die App zu öffnen
    window.location.href = appScheme;

    // Fallback ins Portal nach 1.6s — gibt iOS/Android genug Zeit
    const t = setTimeout(() => {
      document.removeEventListener('visibilitychange', onVisibility);
      if (!didFallback) {
        window.location.replace(webFallback);
      }
    }, 1600);

    return () => {
      clearTimeout(t);
      document.removeEventListener('visibilitychange', onVisibility);
    };
  }, []);

  return (
    <div
      data-testid="app-redirect-page"
      style={{
        minHeight: '100vh',
        background: '#0a0a0a',
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        fontFamily: '-apple-system, BlinkMacSystemFont, system-ui, sans-serif',
        padding: '24px',
        textAlign: 'center'
      }}
    >
      <div style={{ fontSize: 56, marginBottom: 16 }}>📱</div>
      <div style={{ fontSize: 20, fontWeight: 600, marginBottom: 8 }}>
        StrongFit App wird geöffnet…
      </div>
      <div style={{ fontSize: 14, color: '#9ca3af', maxWidth: 320 }}>
        Falls die App nicht startet, wirst du gleich automatisch zum Web-Portal weitergeleitet.
      </div>
    </div>
  );
}
